import { CustomInsightApi } from '@api/ai/model/custom-insights-api.model';
import { CustomInsightType } from './custom-insights-type.model';

export class CustomInsights {
    createdByUserId: number;
    createdDate: number;
    lastModifiedByUserId: number;
    lastModifiedDate: number;
    id: number;
    name: string;
    prompt: string;
    promptType: CustomInsightType;

    constructor(apiModel?: CustomInsightApi) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = this.stripPromptTypePrefix(apiModel.name, apiModel.promptType);
            this.prompt = apiModel.prompt;
            this.promptType = apiModel.promptType;

            this.createdByUserId = apiModel?.createdByUserId;
            this.lastModifiedByUserId = apiModel?.lastModifiedByUserId;
            this.createdDate = apiModel?.createdDate;
            this.lastModifiedDate = apiModel?.lastModifiedDate;

        } else {
            this.name = '';
            this.prompt = '';
        }
    }

    toApiModel(): CustomInsightApi {
        const apiModel: CustomInsightApi = {};

        if (this.id) {
            apiModel.id = this.id;
        }
        if (this.name) {
            apiModel.name = this.name;
        }
        if (this.prompt) {
            apiModel.prompt = this.prompt;
        }

        apiModel.promptType = this.promptType;

        return apiModel;
    }

    clone(): CustomInsights {
        return new CustomInsights(this.toApiModel());
    }

    equals(other: CustomInsights): boolean {
        if (!other) {
            return false;
        }
        if (this.id !== other.id) {
            return false;
        }
        if (this.name !== other.name) {
            return false;
        }
        if (this.prompt !== other.prompt) {
            return false;
        }
        if (this.promptType !== other.promptType) {
            return false;
        }

        return true;
    }

    isEmpty(): boolean {
        return !this.id && !this.name && !this.prompt;
    }

    isValid(): boolean {
        return !!this.name?.trim()
            && !!this.prompt?.trim()
            && this.name.length < 64
            && this.prompt.length < 20000;
    }

    private stripPromptTypePrefix(name: string, promptType: CustomInsightType): string {
        if (!name || !promptType) {
            return name;
        }

        const prefix = `{{${promptType}}}`;
        return name.startsWith(prefix) ? name.slice(prefix.length).trimStart() : name;
    }
}
